import { render } from "./CyanoGallery.vue?vue&type=template&id=7056fc98"
import script from "./CyanoGallery.vue?vue&type=script&lang=js"
export * from "./CyanoGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__